import { Pipe, PipeTransform } from '@angular/core';
import { ArticleCategoryDTO } from '@scip/api';

@Pipe({
  name: 'articleCategoryChip'
})
export class ArticleCategoryChipPipe implements PipeTransform {
  transform(value: ArticleCategoryDTO, isTooltip: boolean = false): string {
    if (!value || !value.categorySpecificIdentifier) {
      return '';
    }

    if (isTooltip) {
      return value.categorySpecificIdentifier + ': ' + value.text;
    } else {
      return value.categorySpecificIdentifier;
    }
  }
}
